angular.module("avlib").directive("buttonFilter", function(){
	return {
		template: require("!html-loader!./ButtonFilterTemplate.html"),
		restrict: "E",
		scope: {
            filter: '=',
            onChange: '&',
		},
		
		controller: ["$scope", function($scope){
            
            $scope.isSelected = function(optionId){
            	if ($scope.filter.type == "singleButtonFilter"){
            		return $scope.filter.selected == optionId;
            	}else if ($scope.filter.type == "buttonFilter"){
            		return $scope.filter.selection.indexOf(optionId) > -1;
            	}
            };
            
			$scope.optionClicked = function(optionId, event){
            	if ($scope.filter.type == "singleButtonFilter"){
            		if ($scope.filter.selected == optionId){
            			$scope.filter.selected = null;
            		}else{
            			$scope.filter.selected = optionId;
            		}
            	}else if ($scope.filter.type == "buttonFilter"){
            		/*
            		 * Atualizando o array de opções selecionadas. Se a opção clicada não
            		 * estava selecionada, vamos selecioná-la, colocando-a no array. Caso
            		 * já estivesse selecionado, faremos o inverso.
            		 */
            		var index = $scope.filter.selection.indexOf(optionId);
            		if (index >= 0){
            			$scope.filter.selection.splice(index, 1);
            		}else{
            			$scope.filter.selection.push(optionId);
            		}
            	}
                if ($scope.filter.optionClicked){
                	$scope.filter.optionClicked(optionId);
                }
                $scope.onChange();
			};
		}],
	};
});
